<div [hidden]="isGeneralFacilityType" class="card">
    <div class="card-body">
        <h6 class="card-title ap-blue">Associated LASU/HYCO Business Potential</h6>
        <div class="row">
            <div class="col-md-7">
                <div class="form-group">
                    <label for="bidCompanies">Bid Companies:</label>
                    <dx-drop-down-box #BidCompaniesSelectBox id="BidCompaniesSelectBox" [(value)]="selectedRowKeys" valueExpr="companyId" displayExpr="companyName"
                        placeholder="Select a value..." [showClearButton]="true" [dataSource]="facility.businessPotential.bidCompanies"  [displayValueFormatter]="displayValueFormatter">
                        <div *dxTemplate="let data of 'content'">
                            <dx-data-grid [dataSource]="facility.businessPotential.bidCompanies" [columns]="['companyName']"
                                [selection]="{ mode: 'multiple' }" [hoverStateEnabled]="true"
                                [paging]="{ enabled: true, pageSize: 10 }" [filterRow]="{ visible: true }"
                                [scrolling]="{ mode: 'virtual' }" [height]="345" keyExpr="companyId"
                                [(selectedRowKeys)]="selectedRowKeys">
                            </dx-data-grid>
                        </div>
                    </dx-drop-down-box>
                </div>
            </div>
            <div class="col-md-1 ml-0 pl-0 mt-4">
                  <dx-button text="Search" type="default" [useSubmitBehavior]="false" (onClick)="searchCompanies()"></dx-button>
            </div>
            <div class="col-md-2">
                <div class="form-group text-center mt-4">
                    <label class="ml-2 mr-2" for="apBid">AP Bid?</label>
                    <dx-check-box id="apBid" [(value)]="facility.businessPotential.apBid"></dx-check-box>
                </div>
            </div>
            <div class="col-md-2">
                <div class="form-group text-center mt-4">
                    <label class="ml-3 mr-2" for="apAmenable">AP Amenable?</label>
                    <dx-check-box id="apAmenable" [(value)]="facility.businessPotential.apAmenable"></dx-check-box>
                </div>
            </div>
        </div>

        <div class="d-md-flex">
            <div class="form-group flex-fill mr-2">
                <label for="estimatedSupplyType">Estimated Supply Type:</label>
                <dx-select-box name="estimatedSupplyType" id="estiamtedSupplyType" [items]="supplyTypes" displayExpr="listItem"
                    valueExpr="listItem" [showClearButton]="true" [(value)]="facility.businessPotential.estimatedSupplyType">
                </dx-select-box>
            </div>

            <div class="form-group flex-fill mr-2">
                <label for="estiamtedSupplyMode">Estimated Supply Mode:</label>
                <dx-select-box name="estimatedSupplyMode" id="estiamtedSupplyMode" [items]="supplyModes" [showClearButton]="true" displayExpr="listItem" valueExpr="listItem"
                    [(value)]="facility.businessPotential.estimatedSupplyMode">
                    <dx-validator>
                        <dxi-validation-rule reevaluate="true" type="custom" [validationCallback]="validateSupplyMode"
                            message="Supply Mode is reqired when 'Business Model' is 'SOG'. ">
                        </dxi-validation-rule>
                    </dx-validator>
                </dx-select-box>
            </div>

            <div class="form-group flex-fill mr-2">
                <label for="estimatedBusinessModel">Estimated Business Model:</label>
                <dx-select-box id="estimatedBusinessModel" [items]="businessModels"
                    displayExpr="businessModelName" valueExpr="businessModelName" [showClearButton]="true"
                    (mouseenter)="toggleBusinessModel()" (mouseleave)="toggleBusinessModel()"
                    [(value)]="facility.businessPotential.estimatedBusinessModel">
                    <dx-tooltip target="#businessModel" position="top" [(visible)]="businessModelVisible">
                    <div *dxTemplate="let data = data; of: 'content'">
                        If Business Model is SOG, select the associated supply mode.
                        OnSite = supplying to single customer.
                        Pipeline = supplying to multiple customers.    
                    </div>
                  </dx-tooltip>
                </dx-select-box>
            </div>

            <div class="form-group flex-fill">
                    <label for="trains"># ASU/Hyco trains:</label>
                    <dx-number-box id="trains" [(value)]="facility.businessPotential.numberOfAsuHycotrains" format="#"></dx-number-box>
            </div>

        </div>

        <div class="d-md-flex">
            <div class="form-group flex-fill mr-2">
                <label for="revenuesmmyr">Revenues mm/yr:</label>
                <dx-number-box id="revenuesmmyr" [(value)]="facility.businessPotential.revenue"
                     ></dx-number-box>
            </div>

            <div class="form-group flex-fill">
                <label for="lastContactedDate">Last Contacted Date:</label>
                <dx-date-box id="lastContactedDate" [(value)]="facility.businessPotential.lastContactedDate">
                </dx-date-box>
            </div>

            <div [hidden]="!isHYCOFacilityType" class="form-group flex-fill ml-2">
                <label for="sogProbability">SOG Probability:</label>
                <dx-number-box id="sogProbability" [max]="100" [min]="1"
                    [(value)]="facility.businessPotential.sogProbability">
                </dx-number-box>
            </div>

        </div>

        <div class="row">
            <div class="col-md-6 pr-0">
                <label for="lastContactedBy">Last Contacted By:</label>
                <div class="row p-0">
                    <div class="col-md-11 pr-0">
                        <dx-text-box readOnly="true" id="lastContactedBy" [(value)]="facility.businessPotential.lastContactedBy">
                        </dx-text-box>
                    </div>
                    <div class="col-md-1 pr-0 pl-1">
                        <dx-button #searchUserLastContactedBy id="searchUserLastContactedBy"
                            (mouseenter)="toggleTooltipLastContactedBy()" (mouseleave)="toggleTooltipLastContactedBy()"
                            (onClick)="searchLastContactedBy()" type="success" icon="group"></dx-button>
                        <dx-tooltip target="#searchUserLastContactedBy" position="top"
                            [(visible)]="lastContactedByTooltipVisible">
                            <div *dxTemplate="let data = data; of: 'content'"> Search </div>
                        </dx-tooltip>
                        <ad-user (searchResult)="updateLastContactedBySearch($event)"
                            [adUserSearchVisible]="lastContactedByVisible" [elementId]="searchUserLastContactedBy.id">
                        </ad-user>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <label for="opportunityLead">Opportunity Lead:</label>
                <div class="row p-0">
                    <div class="col-md-11 pr-0">
                        <dx-text-box readOnly="true" id="opportunityLead" [(value)]="facility.businessPotential.opportunityLead">
                        </dx-text-box>
                    </div>
                    <div class="col-md-1 pr-0 pl-1">
                        <dx-button #searchUserOpportunityLead id="searchUserOpportunityLead"
                            (mouseenter)="toggleOpportunityLead()" (mouseleave)="toggleOpportunityLead()" type="success"
                            icon="group" (onClick)="searchOpportunityLead()"></dx-button>
                        <dx-tooltip target="#searchUserOpportunityLead" position="top"
                            [(visible)]="opportunityLeadTooltipVisible">
                            <div *dxTemplate="let data = data; of: 'content'"> Search </div>
                        </dx-tooltip>
                        <ad-user (searchResult)="updateOpportunityLeadSearch($event)"
                            [adUserSearchVisible]="opportunityLeadVisible" [elementId]="searchUserOpportunityLead.id">
                        </ad-user>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<bidcompany-search (closeEvent)="closeEventSearchCompaniesPopup($event)" (saveEvent)="saveEventSearchCompaniesPopup($event)" [bidCompanySearchVisible]="bidCompanySearchVisible" [facility]="facility"></bidcompany-search>